export default {
  estacionamento: null,
  filaEspera: null,
  areaPet: null,
  formasPag: null,
  happyPromo: null
}